@if (userLoaded()) {
    <div class="h-dvh w-dvw bg-shui-base-1 flex flex-col overflow-hidden">
        @if (showEnvironmentHint()) {
            <app-banner [stage]="stage"></app-banner>
        }
        <app-header></app-header>
        <main class="flex-1 overflow-hidden min-h-0 box-border">
            <router-outlet></router-outlet>
        </main>
        <app-footer></app-footer>
    </div>
    <app-snackbar-container></app-snackbar-container>
    <app-action-required
        class="absolute z-50 right-0 top-[calc(50%-80px)] rotate-[-90deg] origin-bottom-right"
    ></app-action-required>
} @else {
    <div class="h-dvh w-dvw bg-shui-base-1 flex items-center justify-center">
        <div class="flex flex-col items-center gap-8">
            <img
                src="assets/images/healthineers-logo/healthineers-logo-black.svg"
                alt="Siemens Healthineers"
                class="w-48 [html[theme='dark']_&]:hidden"
            />
            <img
                src="assets/images/healthineers-logo/healthineers-logo-white.svg"
                alt="Siemens Healthineers"
                class="w-48 hidden [html[theme='dark']_&]:block"
            />
            <sh-spinner size="s"></sh-spinner>
        </div>
    </div>
}
